import React from 'react';
import { Countdown } from './Countdown';
export function Urgency() {
  return <section className="w-full bg-plum-deep" data-id="element-300" data-mp="2bwe6imbbrd3g">
      <div className="max-w-3xl mx-auto px-5 py-14 sm:py-16 text-center" data-id="element-301" data-mp="2bvcrk6r6u6gg">
        <p className="text-[11px] font-semibold uppercase tracking-[1.8px] text-gold" data-id="element-302" data-mp="1x06lxkw089nn">
          Launch offer
        </p>
        <h2 className="mt-3 font-display font-bold text-white text-2xl sm:text-4xl" data-id="element-303" data-mp="21x6rzvsutcer">
          The launch price ends in:
        </h2>
        <div className="mt-6" data-id="element-304" data-mp="1o58s8bl18sv9">
          <Countdown tone="dark" data-id="element-305" data-mp="1sybowsl3wifo" />
        </div>
        <p className="mt-5 text-sm text-white/75" data-id="element-306" data-mp="1sz4nh69ww1mq">
          After that the launch price{' '}
          <span className="font-semibold text-coral-soft" data-id="element-307" data-mp="1eaqlsyo8ej7r">goes up</span> and stays
          there.
        </p>
      </div>
    </section>;
}